import type { HeadlineResponse } from '@on3/api';
import { Link } from '@on3/ui-lib/components/Link';
import { toFriendlyDate } from '@on3/ui-lib/src/utils/date';
import { ResizedImage } from '@public/components/Image/ResizedImage';

import styles from './ArticleLarge.module.scss';

export const ArticleLarge = ({
  fullUrl,
  featuredImage,
  title,
  author,
  postDate,
  body,
  primaryCategory,
}: HeadlineResponse) => {
  let baseUrl = primaryCategory?.fullUrl;

  if (baseUrl?.endsWith('/')) {
    baseUrl = baseUrl.slice(0, -1);
  }

  return (
    <article className={styles.container}>
      <Link
        className={styles.title}
        href={fullUrl || '/'}
        title={title || 'Article title'}
      >
        <h3>{title}</h3>
      </Link>

      {featuredImage && (
        <Link href={fullUrl || '/'} title={title || 'Article Title'}>
          <ResizedImage
            className={styles.featuredImage}
            {...featuredImage}
            fit="cover"
            gravity="0.5x0.5"
            height={338}
            quality={90}
            width={600}
          />
        </Link>
      )}

      <div className={styles.content}>
        <div className={styles.meta}>
          <Link className={styles.category} href={`${baseUrl}/news/`}>
            {primaryCategory?.name}
          </Link>
          <Link href={`/user/${author?.niceName}/`}>
            <span>{author?.name}</span>
          </Link>
          <dl className={styles.date}>
            <dt>Published at</dt>
            <dd>{toFriendlyDate(postDate)}</dd>
          </dl>
        </div>
        <p className={styles.body}>{body}...</p>
        <Link className={styles.readNow} href={fullUrl}>
          Read Full Story
        </Link>
      </div>
    </article>
  );
};
